import Layout from '@/components/Layout/Layout'
import Dashboard from '@/components/Layout/Dashboard/Index'
import GeneralSettings from '@/components/Layout/GeneralSettings/GeneralSettings'
import MyProfile from '@/components/Layout/MyProfile/MyProfile'
import ChangePassword from '@/components/Layout/MyProfile/ChangePassword'

import Menu from '@/components/Layout/Menu/Menu'
import CreateMenu from '@/components/Layout/Menu/CreateMenu'
import EditMenu from '@/components/Layout/Menu/EditMenu'

import Spenders from '@/components/Layout/Spenders/Spenders'
import Organizations from '@/components/Layout/Organizations/Organizations'
import OrganizationDashboard from '@/components/Layout/Organizations/Dashboard'

import Role from '@/components/Layout/Role/Role'
import CreateRole from '@/components/Layout/Role/CreateRole'
import ShowRole from '@/components/Layout/Role/ShowRole'

import Permissions from '@/components/Layout/Permissions/Permissions'
import ActivityLogs from '@/components/Layout/ActivityLogs/ActivityLogs'
import Clubs from '@/components/Layout/Clubs/Clubs'
import ClubDashboard from '@/components/Layout/Clubs/Dashboard'
import Patenkinder from '@/components/Layout/Patenkinder/Patenkinder'
import PatenkindDetails from '@/components/Layout/Patenkinder/PatenkindDetails'

import Fachstellen from '@/components/Layout/Fachstellen/Fachstellen'
import FachstellenDashboard from '@/components/Layout/Fachstellen/Dashboard'

import Cases from '@/components/Layout/Cases/Cases'
import CaseDetails from '@/components/Layout/Cases/CaseDetails'
import CaseVoting from '@/components/Layout/Cases/CaseVoting'
import CaseReview from '@/components/Layout/Cases/CaseReview'

import Notifications from '@/components/Layout/Notifications/Notifications'
import Blank from '@/components/Layout/Blank'
import Settings from '@/components/Layout/Settings'

import EmailTemplate from '@/components/Layout/EmailTemplates/EmailTemplate'
import CreateEmailTemplate from '@/components/Layout/EmailTemplates/CreateEmailTemplate'
import EditEmailTemplate from '@/components/Layout/EmailTemplates/EditEmailTemplate'

import Admin from '@/components/Layout/Admins/Admin'

import AccountGroups from '@/components/Layout/AccountGroups/AccountGroups'
import AccountClasses from '@/components/Layout/AccountClasses/AccountClasses'
import Accounts from '@/components/Layout/Accounts/Accounts'
import AccountSettings from '@/components/Layout/Accounts/AccountSettings'
import AccountBookings from '@/components/Layout/AccountBookings/AccountBookings'
import IncomeStatement from '@/components/Layout/AccountBookings/IncomeStatement'
import DailyBalanceSheet from '@/components/Layout/AccountBookings/DailyBalanceSheet'
import BookingsStatement from '@/components/Layout/AccountBookings/BookingsStatement'
import BookingLits from '@/components/Layout/AccountBookings/BookingLits'

import SpenderDonation from '@/components/Layout/Spenders/Donation/Donations'

import FileManager from '@/components/Layout/FileManager/FileManager'
import FolderIframe from '@/components/Layout/FileManager/FolderIframe'

import router from '@/router'
export default [{
        path: '/',
        component: Layout,
        beforeEnter: (to, from, next) => {
            if (!localStorage.getItem('auth_token')) {
                router.push({
                    name: 'Login'
                })
            }
            return next();
        },
        children: [{
            path: 'dashboard',
            name: 'Dashboard',
            component: Dashboard,
            meta: {
                title: 'Dashboard',
                icon: 'documentation',
                noCache: true
            }
        }, /* {
            path: 'spenders',
            component: Blank,
            meta: {
                title: 'Spenders',
                icon: 'Menu',
                noCache: true
            },
            children: [{
                path: '/',
                name: 'Spenders',
                component: Spenders,
                meta: {
                    icon: 'Menu',
                    noCache: true,
                    permission: 'spenders-index'
                }
            }, {
                path: ':spender_id/spender-donations',
                name: 'SpenderDonation',
                component: SpenderDonation,
                meta: {
                    title: 'Spender Donation',
                    icon: 'Menu',
                    noCache: true,
                    // permission: 'spenders-index'
                }
            }, ]
        }, */ {
            path: 'organizations',
            component: Blank,
            meta: {
                title: 'Organizations',
                icon: 'Menu',
                noCache: true
            },
            children: [{
                path: '/',
                name: 'Organizations',
                component: Organizations,
                meta: {
                    icon: 'Menu',
                    noCache: true,
                    permission: 'organizations-index'
                }
            }, {
                path: ':organization_slug/details',
                name: 'Details',
                component: OrganizationDashboard,
                meta: {
                    title: 'Dashboard',
                    icon: 'Dashboard',
                    noCache: true
                }
            }]
        }, {
            path: 'clubs',
            component: Blank,
            meta: {
                title: 'Club',
                icon: 'Club',
                noCache: true,
            },
            children: [{
                path: '/',
                name: 'Clubs',
                component: Clubs,
                meta: {
                    permission: 'clubs-index'
                }
            }, {
                path: ':club_slug',
                name: 'ClubDashboard',
                component: ClubDashboard,
                meta: {
                    title: 'Dashboard',
                    icon: 'Dashboard',
                    noCache: true
                }
            }]
        }, {
            path: 'my-profile',
            name: 'MyProfile',
            component: MyProfile,
            meta: {
                title: 'My Profile',
                icon: 'myProfile',
                noCache: true
            }
        }, {
            path: 'change-password',
            name: 'ChangePassword',
            component: ChangePassword,
            meta: {
                title: 'Change Password',
                icon: 'ChangePassword',
                noCache: true
            }
        }, {
            path: 'fachstellens',
            component: Blank,
            meta: {
                title: 'Fachstellen',
                icon: 'time',
                noCache: true,
            },
            children: [{
                path: '/',
                name: 'Fachstellen',
                component: Fachstellen,
                meta: {
                    permission: 'fachstellens-index'
                },
            }, {
                path: ':fachstellen_slug',
                name: 'FachstellenDashboard',
                component: FachstellenDashboard,
                meta: {
                    title: 'Dashboard',
                    icon: 'Dashboard',
                    noCache: true
                }
            }]
        }, {
            path: 'patenkinders',
            component: Blank,
            meta: {
                title: 'Patenkinder',
                icon: 'Patenkinder',
                noCache: true
            },
            children: [{
                path: '/',
                name: 'Patenkinder',
                component: Patenkinder,
                meta: {
                    permission: 'patenkinders-index'
                }
            }, {
                path: ':patenkind_slug/details',
                name: 'PatenkindDetails',
                component: PatenkindDetails,
                meta: {
                    title: 'Patenkinder Details',
                    icon: 'Dashboard',
                    noCache: true,
                    permission: 'patenkinders-show'
                }
            }]
        }, {
            path: 'cases',
            component: Blank,
            meta: {
                title: 'Cases',
                icon: 'Cases',
                noCache: true
            },
            children: [{
                path: '/',
                name: 'Cases',
                component: Cases,
                meta: {
                    // permission: 'patenkinders-index'
                }
            }, {
                path: ':id/details',
                name: 'CaseDetails',
                component: CaseDetails,
                meta: {
                    title: 'Case Details',
                    icon: 'CaseDetails',
                    noCache: true,
                    // permission: 'patenkinders-index'
                }
            }, {
                path: ':id/voting',
                name: 'CaseVoting',
                component: CaseVoting,
                meta: {
                    title: 'Stage 2',
                    icon: 'CaseVoting',
                    noCache: true,
                    // permission: 'patenkinders-index'
                }
            }, {
                path: ':id/review',
                name: 'CaseReview',
                component: CaseReview,
                meta: {
                    title: 'Stage 3',
                    icon: 'CaseReview',
                    noCache: true,
                    // permission: 'patenkinders-index'
                }
            }]
        }, {
            path: 'notifications',
            name: 'Notifications',
            component: Notifications,
            meta: {
                title: 'Notifications',
                icon: 'Menu',
                noCache: true
            }
        }, {
            path: '/',
            component: Settings,
            children: [{
                path: 'general-settings',
                name: 'GeneralSettings',
                component: GeneralSettings,
                meta: {
                    title: 'General Settings',
                    icon: 'GeneralSettings',
                    noCache: true,
                    permission: 'general-settings-update'
                }
            }, {
                path: 'permissions',
                name: 'Permissions',
                component: Permissions,
                meta: {
                    title: 'Permissions',
                    icon: 'Menu',
                    noCache: true,
                    permission: 'permissions-index'
                }
            }, {
                path: 'activity-logs',
                name: 'ActivityLogs',
                component: ActivityLogs,
                meta: {
                    title: 'Activity Logs',
                    icon: 'Menu',
                    noCache: true,
                    permission: 'activity-logs-index'
                }
            }, {
                path: 'admins',
                component: Blank,
                meta: {
                    title: 'Admins',
                    noCache: true
                },
                children: [{
                    path: '',
                    name: 'Admins',
                    component: Admin,
                    meta: {
                        permission: 'admins-index'
                    }
                }]
            }, {
                path: 'email-templates',
                component: Blank,
                meta: {
                    title: 'Email Template',
                    noCache: true
                },
                children: [{
                    path: '',
                    name: 'EmailTemplates',
                    component: EmailTemplate,
                    meta: {
                        permission: 'email-templates-index'
                    }
                }, {
                    path: 'create',
                    name: 'CreateEmailTemplate',
                    component: CreateEmailTemplate,
                    meta: {
                        title: 'Create',
                        noCache: true,
                        permission: 'email-templates-store'
                    }
                }, {
                    path: ':slug/edit',
                    name: 'EditEmailTemplate',
                    component: EditEmailTemplate,
                    meta: {
                        title: 'Edit',
                        noCache: true,
                        permission: 'email-templates-update'
                    }
                }]
            }, {
                path: 'account-groups',
                component: Blank,
                meta: {
                    title: 'Groups',
                    noCache: true,
                },
                children: [{
                    path: '/',
                    name: 'AccountGroups',
                    component: AccountGroups,
                    meta: {
                        permission: 'account-groups-index'
                    }
                }]
            }, {
                path: 'account-classes',
                component: Blank,
                meta: {
                    title: 'Classes',
                    noCache: true,
                },
                children: [{
                    path: '/',
                    name: 'AccountClasses',
                    component: AccountClasses,
                    meta: {
                        permission: 'account-classes-index'
                    }
                }]
            }, {
                path: 'accounts',
                component: Blank,
                meta: {
                    title: 'Accounts',
                    noCache: true,
                },
                children: [{
                    path: '/',
                    name: 'Accounts',
                    component: Accounts,
                    meta: {
                        permission: 'accounts-index'
                    }
                }]
            }, {
                path: 'account-settings',
                component: Blank,
                meta: {
                    title: 'Account Settings',
                    noCache: true,
                },
                children: [{
                    path: '/',
                    name: 'AccountSettings',
                    component: AccountSettings,
                    meta: {
                        permission: 'accounts-index'
                    }
                }]
            }, {
                path: 'roles',
                component: Blank,
                meta: {
                    title: 'Role',
                    icon: 'Role',
                    noCache: true
                },
                children: [{
                    path: '/',
                    name: 'Role',
                    component: Role,
                    meta: {
                        permission: 'roles-index'
                    }
                }, {
                    path: 'create-role',
                    name: 'CreateRole',
                    component: CreateRole,
                    meta: {
                        title: 'Create Role',
                        icon: 'CreateRole',
                        noCache: true,
                        permission: 'roles-store'
                    }
                }, {
                    path: ':id',
                    name: 'ShowRole',
                    component: ShowRole,
                    meta: {
                        title: 'Show Role',
                        icon: 'ShowRole',
                        noCache: true,
                        permission: 'roles-show'
                    }
                }]
            }, {
                path: 'menu',
                component: Blank,
                meta: {
                    title: 'Menu',
                    icon: 'Menu',
                    noCache: true
                },
                children: [{
                    path: '/',
                    name: 'Menu',
                    component: Menu,
                    meta: {
                        permission: 'menu-items-index'
                    }
                }, {
                    path: 'create-menu',
                    name: 'CreateMenu',
                    component: CreateMenu,
                    meta: {
                        title: 'Create Menu',
                        icon: 'CreateMenu',
                        noCache: true,
                        permission: 'menu-items-store'
                    }
                }, {
                    path: ':id/edit',
                    name: 'EditMenu',
                    component: EditMenu,
                    meta: {
                        title: 'Edit Menu',
                        icon: 'EditMenu',
                        noCache: true,
                        permission: 'menu-items-update'
                    }
                }]
            }]
        }, {
            path: 'file-manager',
            component: Blank,
            meta: {
                title: 'File manager',
                noCache: true,
            },
            children: [{
                path: '/',
                name: 'FileManager',
                component: FileManager,
                meta: {}
            }, {
                path: 'folder/:id',
                name: 'Folder',
                component: FolderIframe,
                meta: {
                    title: 'Folder',
                    noCache: true
                }
            }]
        }/*, {
            path: 'accounting',
            component: Blank,
            meta: {
                title: 'Account Bookings',
                noCache: true,
            },
            children: [{
                path: '/',
                name: 'AccountBookings',
                component: AccountBookings,
                meta: {
                    title: 'Account Bookings',
                    permission: 'account-bookings-index'
                }
            }]
        }*/]
    }, {
        path: '/income-statement',
        name: 'IncomeStatement',
        component: IncomeStatement,
        props: true,
        meta: {
            title: 'Income Statement',
            permission: 'account-bookings-index'
        }
    }, {
        path: '/daily-balance-sheet',
        name: 'DailyBalanceSheet',
        component: DailyBalanceSheet,
        props: true,
        meta: {
            title: 'Daily BalanceSheet',
            permission: 'account-bookings-index'
        }
    }, {
        path: '/account-bookings-list',
        name: 'BookingLits',
        component: BookingLits,
        props: true,
        meta: {
            title: 'Account Bookings List',
            permission: 'account-bookings-index'
        }
    },
    {
        path: '/account-bookings-pdf',
        name: 'BookingsStatement',
        component: BookingsStatement,
        props: true,
        meta: {
            title: 'Account Bookings PDF',
            permission: 'account-bookings-index'
        }
    }
]


// WEBPACK FOOTER //
// ./src/components/Layout/router.js